<template>
	<div class="panel bgPanel mt1x cb h28x">
        <loading v-show="isLoading"></loading>
        <div class="title title-bg">
            <span :title="$t('word2010',['昨日PR'])">{{$t('word2010',['昨日PR'])}}</span>
            <div class="tool">
                <Help :code="'pr'" :btnClose="false" class="vaM"></Help>
                <!-- <i class="fa fa-map-marker fs12x cSub mr5"></i>
                <span v-if="weatherAddress.name!= undefined">{{weatherAddress.name}}</span>
                <span v-else>--</span> -->
            </div>
        </div>
        <div fillHeight="parentLastHeight" class="tableSys vaM_E">
            <div>
                <div class="h16x posR" v-if="ringData">
                    <ChartSolidgauge :ringData="ringData" :chartClass="'h16x'" :RingWidth="25" :balance="6"></ChartSolidgauge>
                    <div class="ringContent dpIB_E tableSys vaM_E">
                        <div class="dpIB_E">
                            <span class="cMain pb05x"><span class="fs16x">{{ringData[0]?floatFix(ringData[0]*100,2,'%'):'--'}}</span></span><br>
                            <span class="cMain" :title="$t('word2010',['昨日PR'])">{{$t('word2010',['昨日PR'])}}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <no-result v-show="!ringData"></no-result>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ChartSolidgauge from "@/components/common/chart/ChartSolidgauge.vue"
import Loading from '@/components/common/ui/Loading'
import Help from "@/components/common/Help.vue"
import {getLanguageStr} from "@/util/language.js"
import NoResult from '@/components/common/ui/NoResult'
import * as lib from "@/util/lib.js"
export default {
    name:'Pr',
    components:{ChartSolidgauge,Loading,NoResult,Help},
    data(){
        return{
            isLoading:false,
            ringData:[]
        }
    },
    methods:{
       getLanguageStr,
       floatFix:lib.floatFix,
       show(data){
            this.ringData=[]
            if(data.stationInfo.prYesterday){
                this.ringData.push(data.stationInfo.prYesterday)
            }else{
                this.ringData.push(0)
            }
       },
        // _getList(id){
        //     this.isLoading=true
        //     equipmentApi.StationInfo(id).then(res=>{
        //          this.isLoading=false
        //         this.stationInfo=res
        //     },error=>{
        //         this.isLoading=false
        //          !_.isEmpty(error) && this.$notify(error)
        //     })
        // }
    }
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
.ringContent{position: absolute;top:0;left: 0;width: 100%; text-align: center;height: 100%;z-index: 2;}
</style>





// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/Pr.vue